import { useHistory } from "react-router-dom";

import { useSelector } from "react-redux";
import { dispatch } from "../../state/store";
import { setNotificationsLoading, setNotificationsRefresh } from "../../state/ducks";

import { routePaths, strCode } from "../../consts";
import { log, notificationManagementService, notificationService, t } from "../../services";
import { responseUtil } from "../../utils";
import { useUploadNotificationImage } from "./useUploadNotificationImage";
import { parseErrorMessage } from "./useCreateNotification";

export const useUpdateNotification = () => {
  const loading = useSelector((store) => store.notifications?.loading);
  const refresh = useSelector((store) => store.notifications?.refresh);

  const history = useHistory();

  const { mutationCallback: uploadNotificationImage } = useUploadNotificationImage();

  const mutationCallback = async (
    notification,
    binaryImage,
    { isSameData, isSystemNotification }
  ) => {
    dispatch(setNotificationsLoading(true));

    try {
      let res;

      if (isSystemNotification) {
        res = await notificationManagementService.updateSystemNotification(notification);
      } else {
        res = await notificationManagementService.updateNotification(notification);
      }

      const imageUrl = res?.data?.data?.image;

      if (imageUrl && binaryImage) {
        await uploadNotificationImage(imageUrl, binaryImage);
      }

      if (responseUtil.isResponseSuccessful(res)) {
        if (!isSameData) {
          notificationService.showSuccess({
            title: t(strCode.UPDATE_NOTIFICATION_SUCCESS),
            message: t(strCode.UPDATE_NOTIFICATION_SUCCESS_INFO, {
              name: notification?.notificationName
            })
          });
        }

        dispatch(setNotificationsLoading(false));
        dispatch(setNotificationsRefresh(true));
        history.push(routePaths.NOTIFICATIONS);
      }
    } catch (err) {
      log.error("useUpdateNotification: Failed to update notification", err);
      dispatch(setNotificationsLoading(false));

      notificationService.showError({
        title: t(strCode.UPDATE_NOTIFICATION_ERROR),
        message: t(parseErrorMessage(err))
      });

      throw err;
    }
  };

  return { mutationCallback, loading, refresh };
};
